import React from 'react';
import ReactMarkdown from 'react-markdown';
import RemarkBreaks from 'remark-breaks';
import cx from 'classnames';

import MarkdownImage from './image/MarkdownImage';
import MarkdownHeading from './heading/MarkdownHeading';
import MarkdownLink from './link/MarkdownLink';
import MarkdownList from './list/MarkdownList';
import MarkdownListItem from './list/MarkdownListItem';
import MarkdownParagraph from './paragraph/MarkdownParagraph';

import styles from './Markdown.pcss';

export interface MarkdownProps {
    className?: string;
    usePlainText?: boolean;
    source: string;
}

/* Supported tags with custom components */
const RENDERERS = {
    heading: MarkdownHeading,
    image: MarkdownImage,
    imageReference: MarkdownImage,
    link: MarkdownLink,
    linkReference: MarkdownLink,
    list: MarkdownList,
    listItem: MarkdownListItem,
    paragraph: MarkdownParagraph
};

const DISALLOWED_TYPES: ReactMarkdown.NodeType[] = [
    'blockquote',
    'code',
    'html',
    'inlineCode',
    'table',
    'tableHead',
    'tableBody',
    'tableRow',
    'tableCell',
    'virtualHtml'
];

const DISABLE_ALL_TYPES: ReactMarkdown.NodeType[] = [
    'root',
    'break',
    'paragraph',
    'emphasis',
    'strong',
    'thematicBreak',
    'blockquote',
    'delete',
    'link',
    'image',
    'linkReference',
    'imageReference',
    'table',
    'tableHead',
    'tableBody',
    'tableRow',
    'tableCell',
    'list',
    'listItem',
    'definition',
    'heading',
    'inlineCode',
    'code',
    'html',
    'virtualHtml'
];

const Markdown = (props: MarkdownProps) => {
    const {className, source, usePlainText = false} = props;
    const wrapperClassName: string = cx(styles.wrapper, className);

    const disabledTypes = usePlainText ? DISABLE_ALL_TYPES : DISALLOWED_TYPES;

    return (
        <ReactMarkdown
            className={wrapperClassName}
            disallowedTypes={disabledTypes}
            unwrapDisallowed={true}
            renderers={RENDERERS}
            skipHtml
            source={source}
            plugins={[[RemarkBreaks]]}
        />
    );
};

export default Markdown;
